import KDBush from "kdbush";
import { pointInPolyWindingNumber } from "point-in-polygon-extended";
import { polygonToGoogleMapBounds } from "../api/geofence/utils";

let index;
let points;

export const countOrderWithin = polygon => {
  if (!index || !points) {
    return null;
  }
  if (points.length === 0) {
    return 0;
  }
  const { north, east, west, south } = polygonToGoogleMapBounds(polygon);
  const pointsIndices = index.range(west, south, east, north);
  const result = pointsIndices.reduce((acc, e) => {
    if (
      pointInPolyWindingNumber(
        [points[e].loc.coordinates[0], points[e].loc.coordinates[1]],
        polygon.coordinates[0]
      )
    ) {
      return acc + points[e].count;
    }
    return acc;
  }, 0);
  return result;
};

export const createIndex = pointsArr => {
  points = pointsArr;
  index = new KDBush(
    points,
    p => p.loc.coordinates[0],
    p => p.loc.coordinates[1]
  );
};
